import { defineComponent, createBlock, openBlock, resolveDynamicComponent, withCtx, createElementBlock, Fragment, renderList, createVNode } from "vue";
import _sfc_main$1 from "../PrismicRichText/PrismicRichText.vue.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PrismicTableRow" },
  __name: "PrismicTableRow",
  props: {
    row: {},
    components: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(props.components.tr), { row: _ctx.row }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.row.cells, (cell) => {
            return openBlock(), createElementBlock(Fragment, {
              key: cell.key
            }, [
              cell.type === "header" ? (openBlock(), createBlock(resolveDynamicComponent(props.components.th), {
                key: 0,
                cell
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$1, {
                    field: cell.content,
                    components: _ctx.components
                  }, null, 8, ["field", "components"])
                ]),
                _: 2
              }, 1032, ["cell"])) : (openBlock(), createBlock(resolveDynamicComponent(props.components.td), {
                key: 1,
                cell
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$1, {
                    field: cell.content,
                    components: props.components
                  }, null, 8, ["field", "components"])
                ]),
                _: 2
              }, 1032, ["cell"]))
            ], 64);
          }), 128))
        ]),
        _: 1
      }, 8, ["row"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PrismicTableRow.vue.js.map
